// extracted by mini-css-extract-plugin
module.exports = {"body":"profile_body__2JJDN","footer":"profile_footer__3bvgZ"};